import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import invariant from 'invariant';
import { createBrowserHistory, createMemoryHistory, createHashHistory } from 'history';
var historyTypeMaps = {
  memory: createMemoryHistory,
  browser: createBrowserHistory,
  hash: createHashHistory
};

var History = function () {
  function History() {
    _classCallCheck(this, History);
  }

  _createClass(History, [{
    key: "setup",
    value: function setup(type, config) {
      var _this = this;

      invariant(!this._instance, "L'historique a d\xE9j\xE0 \xE9t\xE9 instanci\xE9, il ne peut l'\xEAtre qu'une seule fois.");
      invariant(Object.keys(historyTypeMaps).indexOf(type) !== -1, "Type d'historique non pris en charge: \"".concat(type, "\"."));
      var createHistory = historyTypeMaps[type];
      this._instance = createHistory(config);
      var history = this._instance;
      ['push', 'replace', 'go', 'goBack', 'goForward'].forEach(function (method) {
        _this[method] = function () {
          var _this$_instance;

          invariant(_this._instance, "L'historique doit \xEAtre param\xE8tr\xE9 via `history.setup()` " + "avant l'appel \xE0 la m\xE9thode `".concat(method, "`."));

          (_this$_instance = _this._instance)[method].apply(_this$_instance, arguments);
        };
      });
      return history;
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      invariant(this._instance, "L'historique doit \xEAtre param\xE8tr\xE9 via `history.setup()` " + "avant de pouvoir r\xE9cup\xE8rer son instance via `history.getInstance()`.");
      return this._instance;
    }
  }]);

  return History;
}();

export default new History();